"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Button_1 = require("@material-ui/core/Button");
const Card_1 = require("@material-ui/core/Card");
const CardContent_1 = require("@material-ui/core/CardContent");
const Dialog_1 = require("@material-ui/core/Dialog");
const DialogActions_1 = require("@material-ui/core/DialogActions");
const DialogContent_1 = require("@material-ui/core/DialogContent");
const Typography_1 = require("@material-ui/core/Typography");
const classnames_1 = require("classnames");
const React = require("react");
const config_1 = require("../config/config");
const Icon_1 = require("../icon/Icon");
const MessagePopupStyle_1 = require("./jss/MessagePopupStyle");
const MessagePopup = ({ visible, onDismiss, title, text, type, classes }) => {
    let icon;
    switch (type) {
        case 'warning':
            icon = (0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'warning', iconType: 'material', className: classes.warning });
            break;
        case 'error':
        default:
            icon = (0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'error_outline', iconType: 'material', className: classes.error });
            break;
    }
    return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ "aria-labelledby": "Popup Message", fullWidth: true, maxWidth: "md", open: visible, className: (0, classnames_1.default)(classes.dialogBackdrop, 'po-widget-dialog'), PaperProps: {
                className: classes.dialog
            } }, { children: [(0, jsx_runtime_1.jsx)(DialogContent_1.default, Object.assign({ className: classes.dialogContent }, { children: (0, jsx_runtime_1.jsx)(Card_1.default, { children: (0, jsx_runtime_1.jsxs)(CardContent_1.default, Object.assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h5', color: 'textPrimary' }, { children: title })), icon, (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'body2', color: 'textPrimary' }, { children: text }))] })) }) })), (0, jsx_runtime_1.jsx)(DialogActions_1.default, Object.assign({ className: classes.dialogActions }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onDismiss, color: config_1.config.internalConfig.BUTTON_BACKGROUND, variant: "text", className: 'textButton' }, { children: "OK" })) }))] })) }));
};
exports.default = (0, core_1.withStyles)(MessagePopupStyle_1.default)(MessagePopup);
//# sourceMappingURL=MessagePopup.js.map